module.exports = __webpack_public_path__ + "static/media/mobile-sign-in.51768630.jpg";